/**
 * Parses a value into a valid, positive (greater than 0) integer.
 * Returns undefined if the value is not a valid positive integer.
 */
export function parsePositiveInteger(
  value: string | number | null | undefined,
): number | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }

  const num = Number(value);

  // Check if it's a finite, positive, whole number
  if (Number.isFinite(num) && Number.isInteger(num) && num > 0) {
    return num;
  }

  return undefined;
}
